import { StoryParagraphsArgs } from "../../../@types/sample_details";
import { pathToExtractedFile } from "../../../util";
import useEmailAttachments from "./useEmailAttachments";

type PivotMap = Record<string, StoryParagraphsArgs>;

const usePivotMap = (
  hash: string | undefined,
  sourceId: number | undefined,
  relationshipId: number | undefined
) => {
  const { attachmentsPath } = useEmailAttachments(
    hash || "",
    relationshipId ?? 0
  );
  const allAttachmentsRoute = pathToExtractedFile(
    hash,
    sourceId,
    attachmentsPath,
    relationshipId
  );

  return {
    pivotMap: {
      attachments: {
        text: "attachments",
        type: 3,
        link: allAttachmentsRoute
      },
      attachment: {
        text: "attachment",
        type: 3,
        link: allAttachmentsRoute
      }
    } as PivotMap
  };
};
export default usePivotMap;
